import { AuthenticationClient, SocialConnectionProvider, User } from "authing-js-sdk"
import MD5 from "crypto-js/md5"
import type { Tenant } from '@/apis/tenant/tenant'

export const getSocialId = (type: SocialConnectionProvider, tenantId?: string) => {
  if (!tenantId) {
    return type
  }
  const socialId = MD5(`${tenantId}:${type}`, { keySize: 16 }).toString().substr(8, 16)
  return socialId
}

export const getAuthenticationClient = (token: string, {appHost, appId}: {appHost: string, appId: string}) => {
  return new AuthenticationClient({
    token,
    appId,
    appHost
  })
}


export const getWechatIdps = (
  data: Pick<
    {
      tenant: Tenant
    },
    'tenant'
  >
) => {

  const { tenant } = data

  let ipdsObj: Record<any, string> = {
    [SocialConnectionProvider.WECHATPC]: SocialConnectionProvider.WECHATPC, // 微信PC扫描
    [SocialConnectionProvider.WECHATMP]: SocialConnectionProvider.WECHATMP // 微信公众号授权
  }

  const authingIdps = tenant?.authingIdps
  if (authingIdps && !!Object.keys(authingIdps).length) {
    const ipds = authingIdps.reduce((pre, { connections }) => {
      return pre.concat(connections.filter(({ enabled }) => enabled))
    }, [])
    ipdsObj = {}
    ipds.forEach(({ type, identifier }) => {
      const _wechatIdps: { [key: string]: string } = {}
      _wechatIdps[type] = identifier
      ipdsObj = {...ipdsObj, ..._wechatIdps}
    })
  }

  return ipdsObj
}